var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { gutter: 20 },
        },
        [
          _c(
            "el-col",
            { attrs: { xl: 14, lg: 24 } },
            [
              _c(
                "el-row",
                { staticClass: "mb10" },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "header-wrap",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customer::customer-list::basic_info")
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "24px 8px",
                          display: "flex",
                          "flex-wrap": "wrap",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "line-item",
                            staticStyle: {
                              "margin-bottom": "32px",
                              width: "100%",
                            },
                          },
                          [
                            _c("div", { staticClass: "line-left" }, [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("customer::customer-list::email")
                                  ) +
                                  "： "
                              ),
                            ]),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$dataCheck(_vm.customerDetail.userEmail)
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "line-item",
                            staticStyle: { "margin-bottom": "32px" },
                          },
                          [
                            _c("div", { staticClass: "line-left" }, [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("customer::customer-list::last_name")
                                  ) +
                                  "： "
                              ),
                            ]),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$dataCheck(_vm.customerDetail.lastName)
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "line-item",
                            staticStyle: { "margin-bottom": "32px" },
                          },
                          [
                            _c("div", { staticClass: "line-left" }, [
                              _c("span", [_vm._v("*")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "customer::customer-list::first_name"
                                    )
                                  ) +
                                  "： "
                              ),
                            ]),
                            _c("div", { staticClass: "content" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$dataCheck(_vm.customerDetail.firstName)
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "line-item" }, [
                          _c("div", { staticClass: "line-left" }, [
                            _vm._v(
                              _vm._s(_vm.$t("customer::customer-list::phone")) +
                                "："
                            ),
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _vm._v(
                              _vm._s(_vm.$dataCheck(_vm.customerDetail.phone))
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "line-item" }, [
                          _c("div", { staticClass: "line-left" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("customer::customer-list::顾客来源")
                              ) + "："
                            ),
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(_vm.customerDetail.firstChannel)
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "mb10" },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "header-wrap",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "customer::customer-list::registered_status"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticStyle: { padding: "16px 8px" } },
                      [
                        _vm._l(
                          _vm.customerDetail.shopCustomerInfos,
                          function (item) {
                            return _c(
                              "el-row",
                              { key: item.id, staticClass: "shop-line" },
                              [
                                _c("el-col", { attrs: { span: 3 } }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "shop-main",
                                      staticStyle: { "font-weight": "bold" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$dataCheck(item.brandName))
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("el-col", { attrs: { span: 5 } }, [
                                  _c("span", { staticClass: "shop-main" }, [
                                    _vm._v(_vm._s(_vm.$dataCheck(item.domain))),
                                  ]),
                                ]),
                                _c("el-col", { attrs: { span: 3 } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "customer::customer-list::buy_count"
                                        )
                                      ) +
                                      "：" +
                                      _vm._s(_vm.$dataCheck(item.orderNum)) +
                                      " "
                                  ),
                                ]),
                                _c("el-col", { attrs: { span: 5 } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "customer::customer-list::grand_total"
                                        )
                                      ) +
                                      "：" +
                                      _vm._s(
                                        _vm.$dataCheck(
                                          _vm.formatNumberMix(item.ltv, 2)
                                        )
                                      ) +
                                      " USD "
                                  ),
                                ]),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "customer::customer-list::join_time"
                                        )
                                      ) +
                                      "：" +
                                      _vm._s(_vm.$dataCheck(item.joinTime)) +
                                      " "
                                  ),
                                ]),
                              ],
                              1
                            )
                          }
                        ),
                        _vm.customerDetail.shopCustomerInfos.length === 0
                          ? _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("p", { staticClass: "none-txt" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "customer::customer-list::customer_no_consume"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "mb10" },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "header-wrap",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("customer::customer-list::customer_tag")
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticStyle: { padding: "8px 0" } },
                      [
                        _vm.customerDetail.userType
                          ? _c(
                              "el-tag",
                              {
                                staticStyle: { margin: "0 10px 10px 0" },
                                attrs: { "disable-transitions": false },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.customerDetail.userType) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { xl: 10, lg: 24 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  {
                    staticClass: "header-wrap",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::detail_info"))
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticStyle: { padding: "32px 8px" } }, [
                  _c("div", { staticClass: "detail-info" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::join_time")) +
                          "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$dataCheck(_vm.customerDetail.joinTime)) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "detail-info" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("customer::customer-list::first_order_time")
                        ) + "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$dataCheck(_vm.customerDetail.firstOrderTime)
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "detail-info" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("customer::customer-list::lastOrderTime")
                        ) + "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$dataCheck(_vm.customerDetail.lastOrderTime)
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "detail-info" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::buy_count")) +
                          "："
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$dataCheck(_vm.customerDetail.orderNum)) +
                          " " +
                          _vm._s(_vm.$t("customer::customer-list::times"))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "detail-info" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::qty")) + "："
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$dataCheck(_vm.customerDetail.qty)) +
                        " " +
                        _vm._s(_vm.$t("customer::customer-list::件")) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "detail-info" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::ltv")) + "："
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$dataCheck(
                            _vm.formatNumberMix(_vm.customerDetail.ltv, 2)
                          )
                        ) + " USD"
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("edit-dialog", {
        attrs: { row: _vm.customerDetail },
        on: { submit: _vm.getDetail },
        model: {
          value: _vm.visiable,
          callback: function ($$v) {
            _vm.visiable = $$v
          },
          expression: "visiable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }